import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast, Toaster } from 'react-hot-toast';
import MasterNavbar from '../components/layout/MasterNavbar';
import { CUSTOMERS_LIST_ENDPOINT, DELETE_CUSTOMER_ENDPOINT } from '../utils/api';

function CustomersShow() {
  const navigate = useNavigate();
  const [customers, setCustomers] = useState([]);

  const handleAddCustomer = () => {
    navigate('/customers/add');
  };

  const handleEdit = (id, token) => {
    navigate(`/customers/edit/${id}/${token}`);
  };


  const handleDelete = async (id, token) => {
    if (!window.confirm('Are you sure you want to delete this customer?')) return;

    try {
      const res = await axios.post(DELETE_CUSTOMER_ENDPOINT, { id, customer_token: token });
      if (res.data.success) {
        toast.success(res.data.message || 'Customer deleted successfully');
        // Remove from state
        setCustomers(prev => prev.filter(c => c.id !== id));
      } else {
        toast.error(res.data.message || 'Failed to delete customer');
      }
    } catch (err) {
      toast.error('Server error during delete');
    }
  };


  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    axios.post(CUSTOMERS_LIST_ENDPOINT, { token })
      .then(res => {
        if (res.data.success && res.data.customers) {
          setCustomers(res.data.customers);
        } else {
          toast.error(res.data.message || 'Failed to fetch customers');
        }
      })
      .catch(() => toast.error('Error fetching customers'));
  }, []);

  return (
    <>
      <MasterNavbar />
      <Toaster position="top-center" />
      <div className="container mt-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4>👥 Customers List</h4>
          <button className="btn btn-success" onClick={handleAddCustomer}>
            ➕ Add Customer
          </button>
        </div>

        <div className="table-responsive">
          <table className="table table-bordered table-hover align-middle">
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>Distributor</th>
                <th>Customer Name</th>
                <th>City</th>
                <th>State</th>
                <th>GST No</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {customers.length > 0 ? (
                customers.map((cust, index) => (
                  <tr key={cust.id}>
                    <td>{index + 1}</td>
                    <td>{cust.distributor_name}</td>
                    <td>{cust.name}</td>
                    <td>{cust.city}</td>
                    <td>{cust.state}</td>
                    <td>{cust.gst_no}</td>
                    <td>
                      <div className="d-flex flex-wrap gap-2">
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() => handleEdit(cust.id, cust.customer_token)}
                        >
                          Edit
                        </button>

                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => handleDelete(cust.id, cust.customer_token)}
                        >
                          Delete
                        </button>

                        <button
                          className="btn btn-secondary btn-sm"
                          onClick={() => navigate(`/customers/profile/${cust.id}/${cust.customer_token}`)}
                        >
                          👤 Manage Profile
                        </button>
                      </div>
                    </td>

                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">No customers found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default CustomersShow;
